import type { CurrentUser } from '@/types/user'

export const E2E_AUTH_STORAGE_KEY = 'structureai_e2e_auth'

function isCandidateUser(value: unknown): value is CurrentUser {
  if (!value || typeof value !== 'object') return false
  const candidate = value as Record<string, unknown>
  return (
    typeof candidate.uid === 'string' &&
    typeof candidate.email === 'string' &&
    typeof candidate.displayName === 'string' &&
    typeof candidate.role === 'string' &&
    typeof candidate.tenantId === 'string' &&
    Array.isArray(candidate.teamIds)
  )
}

export function readE2EUser(): CurrentUser | null {
  if (!import.meta.env.DEV || typeof window === 'undefined') {
    return null
  }

  const raw = window.localStorage.getItem(E2E_AUTH_STORAGE_KEY)
  if (!raw) return null

  try {
    const parsed = JSON.parse(raw) as unknown
    return isCandidateUser(parsed) ? parsed : null
  } catch {
    return null
  }
}

export function clearE2EUser(): void {
  if (typeof window === 'undefined') return
  window.localStorage.removeItem(E2E_AUTH_STORAGE_KEY)
}

export function isE2EAuthActive(): boolean {
  return readE2EUser() !== null
}
